import React from 'react';
import cx from 'classnames';
import Overlay from "../LoadingOverlay/components/Overlay";
import loadingTransition from "../LoadingOverlay/cssTransition.module.css";
import {CSSTransition} from "react-transition-group";
import {createPortal} from "react-dom";


const Modal = (props) => {

    const stopPropagation = (event) => {
        event.stopPropagation();
    };


    return createPortal(
        <CSSTransition classNames={loadingTransition}
                       appear
                       mountOnEnter
                       unmountOnExit
                       in={props.visible}
                       timeout={700}>

            <Overlay>
                <div
                    className={`modal d-block animate__animated ${props.visible ? 'animate__fadeInDown' : 'animate__fadeOutUp'} ${props.className != null ? props.className : ''}`}
                    role="dialog"
                    id="modalComponentHOC"
                    aria-hidden={!props.visible}
                    onClick={props?.onClickBackdrop}>

                    <div
                        className={cx('modal-dialog', props.dialogStyle != null && props.dialogStyle.hasOwnProperty('className') ? props.dialogStyle.className : null)}
                        style={props.dialogStyle != null && props.dialogStyle.hasOwnProperty('inlineStyle') ? props.dialogStyle.inlineStyle : null}
                        role="document" onClick={stopPropagation}>

                        <div className="modal-content">
                            {props.children}
                        </div>

                    </div>
                </div>
            </Overlay>
        </CSSTransition>
        , document.body);
}

export default Modal;
